module.exports = __webpack_public_path__ + "img/googlejobs.03c0b399.svg";